import { DES_AK_TENANT_TOKEN, DES_EVO_TENANT_TOKEN, DES_EVO_USER_TOKEN, DES_I_AM_TOKEN, } from "@jti/fe-common";
import { Rest } from "../Rest";
import { EndpointPlaceholders } from "./CasEndpoints";
import { handleAddPlusToPhone } from "./utils";
export class CasBaseApi extends Rest {
    constructor(baseUrl, tenantToken, ciamToken, userId) {
        super(baseUrl);
        this.tenantToken = tenantToken;
        this.ciamToken = ciamToken;
        this.name = "CasBaseApi";
        this.setCommonHeader(DES_AK_TENANT_TOKEN, this.tenantToken);
        this.setCommonHeader(DES_EVO_TENANT_TOKEN, this.tenantToken);
        this.userId = userId;
        if (this.ciamToken) {
            this.setCommonHeader(DES_I_AM_TOKEN, this.ciamToken);
            this.setCommonHeader(DES_EVO_USER_TOKEN, this.ciamToken);
        }
    }
    formatEndpointUrl(path, replacers) {
        return Object.entries(replacers).reduce((acc, [key, value]) => {
            if (key in EndpointPlaceholders) {
                const replacer = EndpointPlaceholders[key];
                return acc.replace(replacer, value);
            }
            return acc;
        }, path);
    }
    replaceUuid(path, uuid) {
        return this.formatEndpointUrl(path, { UUID: uuid !== null && uuid !== void 0 ? uuid : this.userId });
    }
    replacePhone(path, phone) {
        return this.formatEndpointUrl(path, { PHONE: this.isEvo ? handleAddPlusToPhone(phone) : phone });
    }
    replaceEmail(path, email) {
        return this.formatEndpointUrl(path, { EMAIL: email });
    }
    replaceUserToken(path, token) {
        return this.formatEndpointUrl(path, { USER_TOKEN: token });
    }
    replaceAddressId(path, addressId) {
        return this.formatEndpointUrl(path, { ADDRESS_ID: addressId });
    }
    prepareEvoCustomAttributes(customAttributes) {
        return Object.keys(customAttributes).map((customAttributeCode) => (Object.assign(Object.assign({}, customAttributes[customAttributeCode]), { code: customAttributeCode })));
    }
}
//# sourceMappingURL=CasBaseApi.js.map